import React, { Component } from 'react'

export default class Ci extends Component {
    render() {
        return (
            <main className="page-main-pal container">
                <div className="alocolumns clearfix">
                    <div className="column main">
                    <div className="product-view">
                        <div className="product-essential">
                        <div className="row">
                            <div className="product media product-img-box clearfix col-md-5 col-sm-5 col-xs-12">
                            <div className="gallery-placeholder _block-content-loading" data-gallery-role="gallery-placeholder">
                                <img alt="main product" className="gallery-placeholder__image" src="https://www.kurniateknologi.com/uploads/images/202208/img_kurnia_teknologi_indonesia_x250_62f371cee22e05-45918976-29450087.jpg" />
                            </div>
                            </div>
                            <div className="product-info-main product-shop col-md-7 col-sm-7 col-xs-12">
                            <div className="product-info-price">
                                <div className="page-title-wrapper">
                                    {/* ganti judul product detail */}
                                <h1 className="page-title">
                                    <span className="base" data-ui-id="page-title-wrapper">ZOLL AED Plus Trainer 2</span>
                                </h1>
                                </div>
                                <span data-role="amhideprice-hide-button" id="amhideprice-product-id-314-1040" style={{display: 'none !important'}} />
                            </div>
                            <div className="product attribute overview">
                                {/* ganti product description product detail */}
                                <div className="value" itemProp="description">
                                    <p>Zoll AED Plus Trainer 2</p>
                                    <p>
                                    Tingkatkan keterampilan penyelamatan nyawa Anda dengan Zoll AED Plus Trainer 2, alat pelatihan canggih yang dirancang untuk memberikan pengalaman nyata dalam penggunaan AED. Ideal untuk instruktur CPR dan P3K, Trainer 2 ini memungkinkan siswa merasakan bagaimana menyelamatkan nyawa dengan percaya diri. 
                                    </p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>    
                    </div>
                </div>
            </main>
        )
    }
}
